<template>
<div class="chapter">
<div class="inner_page">
<h2>PRAISE FOR THE WRITING OF EILEEN GOUDGE</h2>
<p class="Praise-Quotes">“Eileen Goudge writes like a house on fire, creating characters you come to love and hate to leave.”</p>
<p class="Praise-Attr" style="margin-bottom:20px;">—Nora Roberts, #1 <i>New York Times</i>–bestselling author</p>
<h3 style="margin-top: 20px;"><i>Woman in Red</i></h3>
<p class="Praise-Quotes">“Once you start this wonderful book, you won’t be able to put it down.”</p>
<p class="Praise-Attr" style="margin-bottom:20px;">—Kristin Hannah, <i>New York Times</i>–bestselling author</p>
<p class="Praise-Quotes">“Beautifully intertwines … two stories, two generations … [Goudge’s] characters are appealing both despite of and because of their problems.”</p>
<p class="Praise-Attr" style="margin-bottom:20px;">—<i>Library Journal</i></p>
<p class="Praise-Quotes">“Eileen Goudge has crafted a beautiful tale of loss, redemption and hope. <i>Woman in Red</i> is a masterpiece.”</p>
<p class="Praise-Attr">—Barbara Delinsky, <i>New York Times</i>–bestselling author</p>
<h3 style="margin-top: 20px;"><i>Blessing in Disguise</i></h3>
<p class="Praise-Quotes">“Powerful, juicy reading.”</p>
<p class="Praise-Attr">—<i>San Jose Mercury News</i></p>
<h3 style="margin-top: 20px;"><i>The Diary</i></h3>
<p class="Praise-Quotes">“A lovely book, tender, poignant and touching. It was a joy to read.”</p>
<p class="Praise-Attr">—<i>Debbie Macomber, New York Times–bestselling author</i></p>
<h3 style="margin-top: 20px;"><i>Garden of Lies</i></h3>
<p class="Praise-Quotes">“A page-turner … with plenty of steamy sex.”</p>
<p class="Praise-Attr" style="margin-bottom:20px;">—<i>New Woman</i></p>
<p class="Praise-Quotes">“Goes down like a cool drink on a hot day.”</p>
<p class="Praise-Attr">—<i>Self</i></p>
<h3 style="margin-top: 20px;"><i>One Last Dance</i></h3>
<p class="Praise-Quotes">“Enlightening and entertaining.”</p>
<p class="Praise-Attr">—<i>The Plain Dealer</i></p>
<h3 style="margin-top: 20px;"><i>Such Devoted Sisters</i></h3>
<p class="Praise-Quotes">“Double-dipped passion … in a glamorous, cut-throat world … Irresistible.”</p>
<p class="Praise-Attr">—<i>San Francisco Chronicle</i></p>
<h3 style="margin-top: 20px;"><i>Thorns of Truth</i></h3>
<p class="Praise-Quotes">“Goudge’s adroit handling of sex and love should keep her legion of fans well-sated.”</p>
<p class="Praise-Attr">—<i>Kirkus Reviews</i></p>
<h3 style="margin-top: 20px;"><i>Woman in Black</i></h3>
<p class="Praise-Quotes">“This novel is the ultimate indulgence—dramatic, involving, and ringing with emotional truth.”</p>
<p class="Praise-Attr">—Susan Wiggs, <i>New York Times</i>–bestselling author</p>
<h3 style="margin-top: 20px;"><i>Woman in Blue</i></h3>
<p class="Praise-Quotes">“Romance, both old and new, abounds. Fans of Goudge’s previous books, romance readers, and lovers of family sagas will enjoy the plot, characters, and resolution.”</p>
<p class="Praise-Attr" style="margin-bottom:20px;">—<i>Booklist</i></p>
<p class="Praise-Quotes">“A touching story with wide appeal.”</p>
<p class="Praise-Attr">—<i>Publishers Weekly</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// praise.vue?d5fb820a